export const siteSettings = {
  name: "Edge Finex",
  link: "https://edgefinex.live",
  email: "support@edgefinex.live",
  appLink: "https://app.edgefinex.live",
};
